import { deserialize } from 'deserialize-json-api'

export default async (axios, resource, params) => {
  const response = await axios.get(resource, { params })
  const data = deserialize(response.data)
  return data
}
